<template>
    <div class="echartdiv">
        <div class="echart" :id="id"></div>
        <downloadExcel v-if="showExcle" :excleName="excleName" :dataExcle="dataArray" type="bar" name=''/>
    </div>
</template>
<script>
import downloadExcel from '@/components/downloadExcel';
export default {
    name:'lineChart',
    components:{ downloadExcel },
    data(){
         return {
             chart:''
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: { 
            type: Array | Object
        },
        barType:{
            type: String,
            default:''
        },
        barWidth:{
            type: String,
            default:'36%'
        },
        jump:{
            type:String,
            default:function(){
                return '';
            }
        },
        xAxisName:{
            type:String,
            default:''
        },
        yAxisName:{
            type:String,
            default:''
        },
        showExcle:{
            type:Boolean,
            default:false
        },
        excleName:{
            type: String,
            default:''
        }
        // colorArr:{
        //     type: Array | Object,
        //     default: function () {
        //         let colr = 
        //         return colr;
        //     }
        // }
    },
    mounted() {
        const that = this
        that.$nextTick(()=> {
            that.init();
        })
    },
    watch: {
        'dataArray': function (n, o) {
            this.init();
        }
    },
    methods: {
        barOption(){
            let _this = this;
            var xWidth = (_this.xAxisName=='')?'10':'50';
            var option = {
                title:{
                    text:this.yAxisName,
                    textStyle:{
                        color:'#525266',
                        fontSize:14,
                        fontWeight:'bold'
                    }
                },
                grid: {
                    top: '40',
                    left: '5',
                    right: xWidth,
                    bottom: '20px',
                    containLabel: true
                },
                tooltip : {
                    trigger: 'axis',
                    axisPointer: {
                        type : 'shadow'   
                    },
                    textStyle: {
                        fontSize:'14'
                    }
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title: '下载',
                        }
                    }
                },
                xAxis : [
                    {
                        type : 'category',
                        name : _this.xAxisName,
                        nameTextStyle :{
                            color:'#525266',
                            fontWeight:'bold'
                        },
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLine: {
                            show: true,
                            lineStyle:{
                                color:'#ebebeb',
                            }
                        },
                        axisLabel : {
                            formatter: '{value}',
                            margin:15,
                            textStyle: {
                                color: '#8a8a99',
                            }
                        },
                        data : _this.dataArray.datetime,
                    }
                ],
                yAxis : [
                    {
                        type : 'value',
                        name : '',
                        nameTextStyle :{
                            color:'#525266',
                            fontWeight:'bold'
                        },
                        axisLine: {
                            show: false,
                            lineStyle:{
                                color:'#ebebeb',
                            }
                        },
                        axisLabel : {
                            show:true,
                            formatter: '{value}',
                            margin:12,
                            textStyle: {
                                color: '#8a8a99',
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color:'#ebebeb',
                            }  
                        },
                    }
                ],
                series : _this.getBarSeries(_this.dataArray.dataName)
            };
            return option;
        },
        getBarSeries(dtname){
            let seriesArr =[],colorArr = [], colr,_this = this;
            if(_this.barType=="warn"){
                colr =  function(params){
                    var cur_val=_this.dataArray.data[0][params.dataIndex];
                    var cur_color='#35ca7f';
                    if(cur_val >= 800){
                        cur_color="#e42e44";
                    }else if(cur_val >=600 && cur_val < 800){
                        cur_color="#f46039";
                    }else if(cur_val >=300 && cur_val < 600){
                        cur_color="#ff941a";
                    }else if(cur_val >=100 && cur_val < 300){
                        cur_color="#8a8a99";
                    }else if(cur_val < 100 ){
                        cur_color="#35ca7f";
                    }
                    return cur_color;
                }
                colorArr.push(colr);
           }else{
                colorArr = [
                    new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,
                        [
                            {offset: 0, color:'#00cbf0' },
                            {offset: 1, color:'#0088d7' }
                        ]
                    ),
                    new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,
                        [
                            {offset: 0, color:'#db0c39' },
                            {offset: 1, color:'#ff406a' }
                        ]
                    )
                ]
             }
            
            for(var i=0;i<dtname.length;i++){
                var tempSeries = _this.setBarSeries(dtname[i], colorArr[i],_this.dataArray.data[i]);
                seriesArr.push(tempSeries);
            }
            return  seriesArr;
        },
        setBarSeries(name,colorArr, data) {
            let series = {
                name:name,
                type:'bar',
                barWidth: this.barWidth,
                itemStyle: {
                    normal:  {
                        color:colorArr
                    }
                },
                data:data
            };
            return series;
        },
        init(){
            let _this = this;
            _this.$echarts.init(document.getElementById(_this.id)).dispose();
            _this.chart = _this.$echarts.init(document.getElementById(_this.id));
            _this.chart.setOption(_this.barOption());
            _this.chart.on('click', function (param) {
                let type = _this.jump;
                if(type != ''){//不为空需要跳转
                    _this.$parent.$refs.child.listJump(type,param.name);
                }
                
            });
            window.addEventListener("resize",function(){
                _this.chart.resize(); 
            });
        },
    },
}
</script>
<style lang="" scoped>
    .echart{width:100%;height:100%}
</style>


// WEBPACK FOOTER //
// src/components/echart/barChart.vue